<template>
  <section class="wrapper">
    <h2 class="title">Este equipo de trabajo no existe 😥</h2>

    <p>Puedes realizar la búsqueda de tu equipo de trabajo dándole click al siguiente botón.</p>

    <a-button class="button" type="primary" @click="goHome">Buscar equipos de trabajo</a-button>
  </section>
</template>

<script setup>
import { useRouter } from "vue-router";

const router = useRouter();

const goHome = () => {
  if (window.location.hostname == "localhost") {
    router.push({ path: "/home", query: { searchModal: true } });
  } else {
    window.location.href = `https://${import.meta.env.VITE_HOSTNAME}/home?searchModal=true`;
  }
};
</script>

<style lang="sass" scoped>
.wrapper
  display: grid
  place-content: center
  justify-items: center
  gap: 16px
  padding: 60px

.title
  text-align: center
  color: $gray-9
  font-weight: 600
  font-size: 30px
  margin: 0

p
  color: $gray-9
  font-size: 20px
  text-align: center
  margin: 0
  font-weight: 400
  width: 80%

.button
  width: 60%
  text-align: center
  margin-top: 15px
</style>
